export default __webpack_public_path__ + "static/media/WNo.8-9.5baf9101.jpg";